module.exports = __webpack_public_path__ + "static/media/80.a81e7a90.jpg";